import filter from 'lodash/filter'
import map from 'lodash/map'
import { useMemo, useState } from 'react'
import type { BarGraphData } from './Settings'

export const useControlsForBarGraphData = (
  data: BarGraphData[] | undefined,
  controledSelectedIdentifiers?: string[],
  controledSelectedXValues?: string[]
) => {
  const [selectedXValues, setSelectedXValues] = useState<string[]>([])
  const [selectedIdentifiers, setSelectedIdentifiers] = useState<
    (string | undefined)[]
  >([])
  const [showControls, setShowControls] = useState(false)

  const { possibleIdentifiers, possibleX } = useMemo(() => {
    if (data === null || data === undefined || data.length === 0) {
      return { possibleIdentifiers: [], possibleX: [] }
    }
    const identifiers = map(Object.keys(data[0]), (key) => {
      if (key !== 'id') return key
    })
    const onlySetIdentifiers = filter(identifiers, (i) => !!i) as string[]
    setSelectedIdentifiers(controledSelectedIdentifiers || onlySetIdentifiers)
    const possibleX = map(data, (d) => d.id)
    setSelectedXValues(controledSelectedXValues || possibleX)
    return {
      possibleIdentifiers: onlySetIdentifiers,
      possibleX: possibleX,
    }
  }, [data, controledSelectedIdentifiers, controledSelectedXValues])
  return {
    selectedXValues,
    selectedIdentifiers,
    possibleIdentifiers,
    possibleX,
    showControls,
    setShowControls,
    setSelectedXValues,
    setSelectedIdentifiers,
  }
}
